export const dataAccessPermission = (perm) => {
  const { role } = JSON.parse(sessionStorage.getItem("authUserRole"));

  if (perm === "OWNER") {
    const userRole =
      role === "admin"
        ? "ALL"
        : role.includes("lbd")
        ? "LBD"
        : role.includes("lbm_lg")
        ? "LBM(LG)"
        : role.includes("lbm_id")
        ? "LBM(ID)"
        : role.includes("ied")
        ? "IED"
        : role.includes("up_power")
        ? "UP POWER"
        : role.includes("up_water")
        ? "UP WATER"
        : role.includes("moblx")
        ? "MOBLX"
        : "";
    return userRole;
  } else if (perm === "OPTION") {
    const userRole =
      role === "admin" || role.includes("_admin")
        ? "ALL"
        : role === "lbd_user"
        ? "LBD"
        : role === "lbm_lg_user"
        ? "LBM(LG)"
        : role === "lbm_id_user"
        ? "LBM(ID)"
        : role === "ied_user"
        ? "IED"
        : role === "up_power_user"
        ? "UP POWER"
        : role === "up_water_user"
        ? "UP WATER"
        : role === "moblx_user"
        ? "MOBLX"
        : "";
    return userRole;
  } else {
    return null;
  }
};
